export default __webpack_public_path__ + "static/media/holidayon12.2b836bc9.jpg";